import React from "react"
import * as styles from "./section.module.css"

interface SectionProps {
	id: string
	children?: React.ReactNode
	className?: string
	wrapperClassName?: string
}

export default function Section({
	children,
	id,
	className,
	wrapperClassName,
}: SectionProps) {
	return (
		<section id={id} className={`${styles.section} ${className}`}>
			<div className={`${styles.wrapper} ${wrapperClassName}`}>{children}</div>
		</section>
	)
}
